export default "__VITE_ASSET__D8ztl1dc__"